import { Component } from '@verndale/core'
import { KEYCODE, classNames } from '../utils'

class ApplicationListing extends Component {
  setupDefaults() {
    this.dom = {
      $jumpLinks: this.el.querySelector('.applications-listing__list'),
      $navWrapper: this.el.querySelector('.applications-listing__wrapper'),
      $searchInput: this.el.querySelector('.search-form__input'),
      $clearButton: this.el.querySelector('.search-form__clear'),
      $alphabet: this.el.dataset.alphabet
    }

    this.setObserver()
    this.createSections()
    this.createJumpLinks()
    this.handleObserveSections()
  }

  handleObserveSections() {
    const observedSections = document.querySelectorAll('.applications-listing__sections')
    observedSections.forEach((section) => {
      this.observer.observe(section)
    })
  }

  createSections() {
    const container = document.querySelector('.applications-listing__sections-container')
    const cardsTitle = document.querySelectorAll('.applications-listing__link')
    const firtsLetters = Array.from(cardsTitle).map((title) => title.title.charAt(0))
    const jumplinksHeight = this.el.querySelector('.applications-listing__container').offsetHeight
    this.cleanRepeated = firtsLetters.filter((c, index) => firtsLetters.indexOf(c) === index).sort()
    this.cleanRepeated.map((section) => {
      const sectionTag = document.createElement('section')
      sectionTag.setAttribute('id', `jump-link-section-${section}`)
      sectionTag.setAttribute('role', 'list')
      sectionTag.classList.add('applications-listing__sections')
      this.observer.observe(sectionTag)
      Array.from(cardsTitle).map((title) =>
        title.title.charAt(0) === section ? sectionTag.appendChild(title.parentNode) : null
      )
      container.appendChild(sectionTag)
    })
    container.style.paddingBottom = `calc(88vh - ${jumplinksHeight}px)`
    container.classList.add('applications-listing__sections-container--show')
  }

  setObserver() {
    const options = {
      root: null,
      treshold: 0,
      rootMargin: '-17% 0% -82%'
    }
    this.observer = new IntersectionObserver((entries) => this.handleOnIntersect(entries), options)
  }

  createJumpLinks() {
    this.dom.$jumpLinks.innerHTML = ''
    this.cloneJumpLinks = this.dom.$jumpLinks.cloneNode(true)
    if (this.dom.$alphabet) {
      this.alphabetArray = JSON.parse(this.dom.$alphabet).sort()
      this.alphabetArray.forEach((section) => {
        const disabled = this.cleanRepeated.find((x) => x === section)
        this.cloneJumpLinks.innerHTML += `<a class='applications-listing__item ${
          disabled ? '' : 'applications-listing__item--disable'
        } ' href="#jump-link-section-${section}">${section}</a>`
      })
    }
    this.dom.$jumpLinks.innerHTML = this.cloneJumpLinks.innerHTML

    this.alphabetElements = this.dom.$jumpLinks.querySelectorAll('a')
    this.navJumpLink = document.querySelectorAll('.applications-listing__item')
  }

  addListeners() {
    this.dom.$jumpLinks.addEventListener('click', (e) => this.handleClick(e))
    this.dom.$searchInput.addEventListener('input', this.handleTextChange.bind(this))
    this.dom.$clearButton.addEventListener('click', this.handleClear.bind(this))
    this.dom.$searchInput.addEventListener('keydown', this.handleKeyDown.bind(this))
    window.addEventListener('resize', this.setObserver.bind(this))
  }

  cleanActiveState() {
    this.navJumpLink.forEach((item) =>
      item.classList.remove('applications-listing__item--scroll-active')
    )
  }

  handleOnIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.cleanActiveState()
        const id = `#${entry.target.id}`
        Array.from(this.navJumpLink)
          .find((x) => x.getAttribute('href') === id)
          ?.classList.add('applications-listing__item--scroll-active')
      }
    })
  }

  handleClick(e) {
    e.preventDefault()
    const jumpLinks = this.el.querySelectorAll('.applications-listing__item')

    jumpLinks.forEach((link) => {
      if (link.classList.contains('applications-listing__item--active')) {
        link.classList.remove('applications-listing__item--active')
      }
    })

    e.target.classList.add('applications-listing__item--active')

    const alphabetSections = document.querySelectorAll('.applications-listing__sections')
    const id = e.target.getAttribute('href').substring(1)
    const offset = this.el.querySelector('.applications-listing__container').offsetHeight
    const target =
      Array.from(alphabetSections).find((x) => x.getAttribute('id') === id)?.offsetTop - offset
    window.scroll({
      top: target,
      behavior: 'smooth'
    })
  }

  handleTextChange(e) {
    e.preventDefault()
    const value = e.target.value.toLowerCase()
    const options = this.el.querySelectorAll('.applications-listing__link')
    if (value.length > 2) {
      this.dom.$clearButton.style.display = 'block'
      this.alphabetElements.forEach((element) =>
        element.classList.add('applications-listing__item--disable')
      )
      Array.from(options).map((option) => {
        if (!option.innerText.toLowerCase().includes(value)) {
          option.classList.add('applications-listing__link--hide')
        } else {
          option.classList.remove('applications-listing__link--hide')
          const alphabetIndex = this.alphabetArray.indexOf(option.innerText[0].toUpperCase())
          this.alphabetElements[alphabetIndex].classList.remove(
            'applications-listing__item--disable'
          )
        }
      })
    } else {
      this.showList()
    }
    if (!value.length) this.dom.$clearButton.style.display = 'none'
  }

  showList() {
    const options = this.el.querySelectorAll('.applications-listing__link')
    Array.from(options).map((option) => {
      option.classList.remove('applications-listing__link--hide')
      const alphabetIndex = this.alphabetArray.indexOf(option.innerText[0].toUpperCase())
      this.alphabetElements[alphabetIndex].classList.remove('applications-listing__item--disable')
    })
  }

  handleKeyDown(e) {
    const key = e.keyCode
    switch (key) {
      case KEYCODE.ESCAPE:
        this.handleClear()
        this.showList()
        break
      case 13:
        e.preventDefault()
        break
    }
  }

  handleClear() {
    this.dom.$searchInput.value = ''
    this.dom.$clearButton.style.display = 'none'
    this.showList()
  }
}

export default ApplicationListing
